export enum CouponStatus {
  ACTIVE = 'ACTIVE',
  REDEEMED = 'USED',
  EXPIRED = 'EXPIRED',
  CANCELED = 'CANCELED',
}

export enum CouponStatusColor {
  GREEN = '#1db01a',
  BLUE = '#002775',
  RED = '#b3301e',
  GRAY = '#7b7b7b',
}
